module.exports = __webpack_public_path__ + "media/common/images/badges/active/zapaleny_ctenar-6c9681294dc1381dcfc8359e458737e2.svg";